<template>
  <div class="c-main-service-box">
    <button class="btn" :style="{ 'background-color': data.bgColor }" @click="handleClick(data.route)">
      <img class="btn__img" :src="data.icon" />
      <span class="btn__label">{{ data.label }}</span>
    </button>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'MainServiceBox',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const router = useRouter();
    const handleClick = (route) => {
      console.log('?');
      router.push(route);
    };

    return {
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.btn {
  @include flex(center);
  outline: none;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  @include padding(10px 15px);
  height: 60px;
  border-radius: 30px;
  box-shadow: 0px 3px 10px #0000001a;
  // transform: scale(0.7);
  white-space: nowrap;

  &__img {
    width: 30px;
  }

  &__label {
    @include font-style($c-white, 18, 500, 2px, 28px);
    display: inline-block;
    margin-left: 12px;
  }
}

@media screen and (min-width: $pc) {
  .btn {
    width: 100%;
    @include padding(20px 30px);
    height: 90px;
    border-radius: 45px;

    &__img {
      width: auto;
    }

    &__label {
      @include font-style($c-white, 25, 500, 2px, 28px);
      display: inline-block;
      margin-left: 12px;
    }
  }
}
</style>
